import React from 'react';
import {TheNews} from './sub-view/the-news';
import {AdvisoryContent} from './sub-view/advisory-content';
import {UserLayout} from 'components/layouts/user';

class UserDashboard extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div>
        <h1 className="user-header">Bảng tin</h1>
        <TheNews/>
        <h1 className="user-header">Tư vấn miễn phí</h1>
        <AdvisoryContent/>
      </div>
    );
  }
}

export default UserDashboard;



// WEBPACK FOOTER //
// ./components/users/UserDashboard.jsx